module.exports = __webpack_public_path__ + "d704bb3d579b7d5e40880c75705c8a71.woff";